export { ProtectedRouteWithToast } from './ProtectedRouteWithToast'

import { AppRoutes } from './AppRoutes'
export default AppRoutes
